import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';
import { getAccessToken } from '@/services/api';
import { Loading } from './loading';

interface ProtectedRouteProps {
  children: React.ReactNode;
  roles?: string[];
  permissions?: string[];
  fallback?: string;
}

export function ProtectedRoute({
  children,
  roles,
  permissions,
  fallback = '/login',
}: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading, user, hasAnyRole, hasPermission } =
    useAuthStore();

  // If no token exists at all, redirect immediately (don't show loading)
  if (!getAccessToken() && !isAuthenticated) {
    return <Navigate to={fallback} state={{ from: location }} replace />;
  }

  if (isLoading) {
    return <Loading fullScreen />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to={fallback} state={{ from: location }} replace />;
  }

  // Check role-based access
  if (roles && roles.length > 0 && !hasAnyRole(roles)) {
    return <Navigate to="/sin-acceso" replace />;
  }

  // Check permission-based access
  if (permissions && permissions.length > 0) {
    const hasAllPermissions = permissions.every((p) => hasPermission(p));
    if (!hasAllPermissions) {
      return <Navigate to="/sin-acceso" replace />;
    }
  }

  return <>{children}</>;
}
